// extracted by mini-css-extract-plugin
module.exports = {"itemsWrapper":"_6ba2042","itemBox":"_b13825c","countryList":"_d61cf01","phoneNumberBox":"_bd92858","dropdownLabel":"_072f2ef","wrapper":"_a3ed7bc","info":"_c0fb609"};